export enum BlockTypes {
	Default = 'default',
	Grey = 'grey'
}

export type BlockTypeKeys = keyof typeof BlockTypes;
